class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;

    if (!this.form) return;

    this.onSubmit = (e) => {
      e.preventDefault();

      const formData = new FormData(this.form);

      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        const property = /properties\[(?<propertyKey>.+)\]/gm.exec(name);

        if (!property) {
          data[name] = value;
        } else {
          if (!("properties" in data)) {
            data.properties = {};
          }
          data.properties[property.groups.propertyKey] = value;
        }
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      window.addToCart(data, {
        onAfterAdd: () => {
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        },
        onError: () => {
          const errorEl = document.createElement("div");
          errorEl.classList.add("add-to-cart-error");
          errorEl.innerHTML = window.variantStrings.addToCartError;

          this.form.append(errorEl);

          setTimeout(() => {
            errorEl.remove();
          }, 4000);
        },
      });
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
